import { Player, Controls } from '@lottiefiles/react-lottie-player'
import { Typography, Box } from '@mui/material'
import NoInternetAnimation from './NoInternetAnimation.json';
import "./NoInternetMessage.scss"

const NoInternetMessage = () => {
  const handleNetworkStatus = () => {
    window.location.reload();
  }

  return (
    <Box className="verticalH100 justifyCenter flexColumn">
    <Box className="flexColumn justifyCenter noInternetMessageContainer">
      <Player autoplay loop src={NoInternetAnimation} >
        <Controls
          visible={false}
          buttons={['play', 'repeat', 'frame', 'debug']}
        />
      </Player>
      <Box className="actionBtn">
      <Typography component={"p"} className="fw600 font36 colorPrimary mb10 textCenter">
        No Internet Connection
      </Typography>
      <button className="btnSubvendor" onClick={handleNetworkStatus}>
        Try again
      </button>
      </Box>    
    </Box>
    </Box>
  )
}

export default NoInternetMessage

